<template>
  <!-- 顾问团队-->
  <section id="team">
    <div class="caption">
      <h2>顾问团队</h2>
      <span>CONSULTANT TEAM</span>
    </div>

    <div class="team">
      <div class="card">
        <div class="img"></div>
        <div class="body">
          <h1>姚睿</h1>
          <h2>男 &nbsp; 34 岁(1985 年 5 月) &nbsp; 10年以上 年工作经验 &nbsp; 本科</h2>
          <p>
            根据公司产品概念负责产品软件的研发、开发、规划和技术人员的跟进、对接工作。参与公司发展战略和计划的制定，把控产品开发的方向。负责对同行同类产品的市场调研、需求分析、产品机会发现；定期对自身产品、整体行业、竞争对手等进行数据分析并评估。
          </p>
          <p>任职期间，带领研发团队完成了故宫博物院、八达岭长城、中国人民革命军事博物馆、中国科技馆、上海科技馆等30余个项目的票务系统建设。</p>
        </div>
      </div>

      <div class="card">
        <div class="img"></div>
        <div class="body">
          <h1>毛智超</h1>
          <h2>男 &nbsp; 39 岁(1980 年 10 月) &nbsp; 10年以上工作经验 &nbsp; 本科</h2>
          <p>为北京市市属11家公园及中国园林博物馆梳理日常业务，协调公园票务管理、财务、信息化等多部门，为其制定网络售验票相关业务规范并监督实施。</p>
          <p>任职期间，带领研发团队完成了故宫博物院、八达岭长城、中国人民革命军事博物馆、中国科技馆、上海科技馆等30余个项目的票务系统建设。</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scope>
section {
  /* 团队 */
  &#team {
    margin-bottom: 30px;

    > .team {
      display: flex;
      flex-direction: column;
      align-items: center;

      > .card {
        display: flex;
        flex-direction: row;
        margin: 10px 0;
        width: 60%;
        border-width: 0;

        > .img {
          background: url(../../assets/images/aboutus/team.png) no-repeat center;
          background-size: contain;
          min-width: 220px;
          max-width: 300px;
          min-height: 200px;
        }

        > .body {
          display: flex;
          flex-direction: column;
          justify-content: center;

          > h1 {
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 5px;
          }

          > h2 {
            margin-top: 5px;
            margin-bottom: 5px;
            font-size: 9px;
            font-weight: bold;
          }

          > p {
            font-size: 9px;
            // text-indent: 28px;
            text-align: justify;
          }
        }
      }
    }
  }
}
</style>